import { useState } from 'react';

import { SharedAppStateContext } from './context';

import type { ReactElement, ReactNode } from 'react';
import type { FeatureFlag } from '~/common/types/settings';
import type { CreateBookingRestRequest } from '~/services/bookings/types';

type Props = {
  children: ReactNode;
  featureFlags: FeatureFlag[];
};

export const SharedAppStateProvider = ({ featureFlags, children }: Props): ReactElement => {
  const [lastBookingEnquiry, setLastBookingEnquiry] = useState<CreateBookingRestRequest | null>(
    null
  );

  return (
    <SharedAppStateContext.Provider
      value={{ featureFlags, lastBookingEnquiry, setLastBookingEnquiry }}
    >
      {children}
    </SharedAppStateContext.Provider>
  );
};
